import { useEffect, useState } from 'react'
import { useAppSelector } from '../../../state/hooks'
import { selectIsFulfilmentPopoverOpen } from '../../../state/slices/uiStateSlice'
import { isMarkedAsUnfulfilled, isValidCustomer } from '../../../functions/sale'
import {
  selectSaleCustomer,
  selectSaleStatus,
} from '../../../state/slices/currentSale/currentSaleSlice'
import { isMissingContactInfo } from '../sale-line-item/fulfilment/popover/LineItemFulfillmentUtils'

/**
 * Hook to check if a sale is unfullfilled and the customer is invalid / missing contact details
 */
export const useUnfulfilledSaleInvalidCustomer = () => {
  const isFulfillmentPopoverOpen = useAppSelector(selectIsFulfilmentPopoverOpen)
  const saleStatus = useAppSelector(selectSaleStatus)
  const saleCustomer = useAppSelector(selectSaleCustomer)
  const [isInvalidCustomer, setIsInvalidCustomer] = useState(false)
  const [isMissingCustomerContact, setIsMissingCustomerContact] = useState(
    false
  )

  useEffect(() => {
    const result =
      isMarkedAsUnfulfilled(saleStatus) && !isValidCustomer(saleCustomer)

    setIsInvalidCustomer(result)
  }, [saleStatus, saleCustomer])

  useEffect(() => {
    const isMissingCustomerContactInfo =
      isMarkedAsUnfulfilled(saleStatus) &&
      isValidCustomer(saleCustomer) &&
      isMissingContactInfo(saleCustomer)

    setIsMissingCustomerContact(isMissingCustomerContactInfo)
  }, [saleStatus, saleCustomer])

  return {
    isFulfillmentPopoverOpen,
    isUnfulfilledSaleInvalidCustomer: isInvalidCustomer,
    isUnfulfilledSaleMissingCustomerContact: isMissingCustomerContact,
  }
}
